// Mirrors the C# RevenueStream enum — values must match exactly for the `revenueStreamType` query param.
export enum RevenueStreamEnum {
  All = 'All',
  Equipment = 'Equipment',
  Contracting = 'Contracting',
}
